import { render, staticRenderFns } from "./SubTable.vue?vue&type=template&id=1424dd68&scoped=true&"
import script from "./SubTable.vue?vue&type=script&lang=js&"
export * from "./SubTable.vue?vue&type=script&lang=js&"
import style0 from "./SubTable.vue?vue&type=style&index=0&id=1424dd68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1424dd68",
  null
  
)

export default component.exports